import * as api from '../../api/api-confirmar-ingreso-recobro';
import { 
    GET_CONFIG_FORM36,
    POST_CONFIRMAR_RECOBRO,
    GET_ANTECEDENTES_RECOBRO
   
} from '../types';

export const configuracionFormAction36 = (query) => ({
    type: GET_CONFIG_FORM36,
    payload: api.getConfiguracionForm36(query)
});
export const postConfirmarRecobro = (data) => ({
    type: POST_CONFIRMAR_RECOBRO,
    payload: api.postConfirmarRecobro(data)
});
export const AntecedentesRecobro = (query) => ({
    type: GET_ANTECEDENTES_RECOBRO,
    payload: api.getAntecedentesRecobro(query)
});
